export const IMAGE_COLLECTION = 'ImageCollection';
export const HERO_ELEMENT = 'HeroElement';

export const LEGACY_HERO_ELEMENT_DISPLAY_NAME = 'Banner Images';
export const LEGACY_IMAGE_COLLECTION_DISPLAY_NAME = 'Gallery';
